import { Heading } from 'src/components/Heading';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';
import { StepBuilder } from '../StepBuilder';
import { useWizard } from '../components/wizard/WizardContext';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { CommunicationChannel } from 'src/services/campaigns/campaigns.interface';

const BuildYourOutreachFlowContent = () => {
  const navigate = useNavigate();

  const { campaignAutomation, currentStep, nextStep, saveCampaignAutomation } =
    useWizard();

  const hasInvalidFollowup = campaignAutomation.followUpCommunications.some(
    (step) => {
      if (step.contactVia === CommunicationChannel.CALL) {
        return !step.agentOption;
      }
      if (step.contactVia === CommunicationChannel.EMAIL) {
        return !(step.emailSubject && step.emailBody);
      }
      if (step.contactVia === CommunicationChannel.SMS) {
        return !(step.smsBody && step.smsBody.trim().length > 0);
      }
      return false;
    },
  );

  const handleSaveAndExit = async () => {
    const campaignSaved = await saveCampaignAutomation();
    if (campaignSaved) navigate('/beta/campaigns');
  };

  return (
    <div className="flex-1">
      <Heading
        title="Build your outreach flow"
        subtitle={`${currentStep}/3`}
        backAction={() => navigate('/beta/campaigns')}
        fixedHeader
      >
        <div className="flex gap-2 mt-3">
          <Button
            variant="outlined"
            size="small"
            onClick={handleSaveAndExit}
            disabled={!campaignAutomation.agentOption || hasInvalidFollowup}
          >
            Save & Exit
          </Button>
          <Button
            size="small"
            onClick={() => {
              nextStep();
            }}
            disabled={!campaignAutomation.agentOption || hasInvalidFollowup}
          >
            Next
          </Button>
        </div>
      </Heading>
      <div className="p-4 flex justify-center">
        <div className="w-full max-w-[850px]">
          <StepBuilder hideTimeWindow={false} />
        </div>
      </div>
    </div>
  );
};

export default withIntegrationApp(BuildYourOutreachFlowContent);
